<template>
  <div class="container py-1">
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="inline">
        <a-input-search
          placeholder="请输入区域或地址开始查询资产"
          style="width: 50%"
          v-model="address"
          @search="onSearch"
          :allowClear="true"
        />

        <standard-form-row
          title="房源位置"
          block
          style="padding-bottom: 11px; padding-top: 20px"
        >
          <a-form-item style="margin-top: -4px">
            <tag-select v-model="district">
              <tag-select-option value="310116">金山区</tag-select-option>
              <tag-select-option value="OTHER_REGION"
                >其他区域</tag-select-option
              >
            </tag-select>
          </a-form-item>

          <a-form-item
            v-if="districtList.includes('310116') && areaList.length > 0"
          >
            <tag-select v-model="town" :key="'town-' + areaList.length">
              <tag-select-option
                v-for="item in areaList"
                :key="item.XZQYDM"
                :value="item.XZQYDM"
              >
                {{ item.XZQYMC }}
              </tag-select-option>
            </tag-select>
          </a-form-item>
        </standard-form-row>

        <standard-form-row title="租赁用途" block style="padding-bottom: 11px">
          <a-form-item
            v-if="leaseUseTypeList.length > 0"
            style="margin-top: -4px"
          >
            <tag-select
              v-model="leaseUseType"
              :key="'leaseUseType-' + leaseUseTypeList.length"
            >
              <tag-select-option
                v-for="item in leaseUseTypeList"
                :key="item.value"
                :value="String(item.value)"
              >
                {{ item.note }}
              </tag-select-option>
            </tag-select>
          </a-form-item>
        </standard-form-row>

        <standard-form-row title="房屋面积" block style="padding-bottom: 11px">
          <a-form-item style="margin-top: -4px">
            <tag-select v-model="floorSpace">
              <tag-select-option value="1">＜100㎡</tag-select-option>
              <tag-select-option value="2">100-300㎡</tag-select-option>
              <tag-select-option value="3">300-500㎡</tag-select-option>
              <tag-select-option value="4">500-1000㎡</tag-select-option>
              <tag-select-option value="5">＞1000㎡</tag-select-option>
            </tag-select>
          </a-form-item>
        </standard-form-row>
      </a-form>
    </a-card>

    <div style="display: flex; margin-top: 20px">
      <!-- 左侧列表 -->
      <div
        style="
          width: 350px;
          display: flex;
          flex-direction: column;
          height: 800px;
          padding: 0 2px;
        "
      >
        <div style="flex: 1; overflow-y: auto; padding: 2px">
          <a-spin :spinning="loading">
            <a-list
              v-if="paginatedList.length > 0"
              :data-source="paginatedList"
              item-layout="vertical"
              split
              :bordered="true"
            >
              <a-list-item
                v-for="item in paginatedList"
                :key="item.id"
                @mouseenter="highlight(item.id)"
                @mouseleave="unhighlight(item.id)"
                class="clickable-item"
              >
                <a @click="showDetail(item)">
                  <a-list-item-meta>
                    <template slot="title">
                      <div class="house-title" :title="item.data.address">
                        {{ item.data.address }}
                      </div>
                    </template>

                    <template slot="description">
                      <div style="color: #555; font-size: 14px">
                        用途：{{ item.data.leaseUseTypeText || "--" }}
                      </div>
                      <div style="color: #555; font-size: 14px">
                        面积：{{ item.data.rentCount || "--" }}㎡
                      </div>
                      <div
                        style="
                          color: #f5222d;
                          font-size: 15px;
                          font-weight: bold;
                          margin-top: 3px;
                        "
                      >
                        价格：{{ formatPrice(item.data) }}
                      </div>
                    </template>
                  </a-list-item-meta>
                </a>
              </a-list-item>
            </a-list>

            <div
              v-else
              style="
                text-align: center;
                color: #888;
                margin-top: 260px;
                font-size: 14px;
              "
            >
              当前区域暂无资产
            </div>
          </a-spin>
        </div>

        <div
          style="padding: 8px 0; text-align: center; border-top: 1px solid #eee"
        >
          <a-pagination
            v-if="visibleList.length > pageSize"
            :current="currentPage"
            :pageSize="pageSize"
            :total="visibleList.length"
            @change="handlePageChange"
            size="small"
          />
        </div>
      </div>

      <!-- 地图区域 -->
      <TdtMapFind
        ref="mapRef"
        :tk="tk"
        :center="[121.33789, 30.74402]"
        :zoom="10"
        :markers="generateMarker()"
        @visible-update="handleVisibleUpdate"
        @marker-title-click="showDetail"
      />
    </div>
  </div>
</template>

<script>
import TdtMapFind from "@/components/TdtMapFind.vue";
import StandardFormRow from "@/components/StandardFormRow";
import TagSelect from "@/components/TagSelect";
import { listProject } from "@/api/publicInfo/PublicInfo.js";
import {
  initAreaListJINSHAN,
  initLeaseUseType,
} from "@/api/shexgrp/InitDictionaries.js";

const TagSelectOption = TagSelect.Option;

export default {
  components: {
    TagSelect,
    TagSelectOption,
    StandardFormRow,
    TdtMapFind,
  },

  data() {
    return {
      tk: "a3789da931616fce36077d6fd5712667",

      loading: false,

      address: "",

      district: {},
      districtList: [],

      town: {},
      townList: [],

      leaseUseType: {},
      leaseUseTypeSelectedList: [],

      floorSpace: {},
      floorSpaceList: [],

      areaLoading: false,
      areaList: [],

      leaseUseTypeLoading: false,
      leaseUseTypeList: [],

      asset: [],
      visibleList: [],

      currentPage: 1,
      pageSize: 6,
    };
  },

  computed: {
    paginatedList() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.visibleList.slice(start, start + this.pageSize);
    },
  },

  mounted() {
    this.initAreaVisible();
    this.initLeaseUseTypeVisible();
    this.markerClusterer();
  },

  watch: {
    district(newVal) {
      this.currentPage = 1;

      this.districtList = this.screen(newVal, this.districtList, [
        "310116",
        "OTHER_REGION",
      ]);

      // 如果取消金山区，则清空镇级筛选
      if (!this.districtList.includes("310116")) {
        this.town = {};
        this.townList = [];
      }

      this.markerClusterer();
    },

    town(newVal) {
      this.currentPage = 1;

      const initList = this.areaList.map((item) => item.XZQYDM);

      this.townList = this.screen(newVal, this.townList, initList);

      this.markerClusterer();
    },

    leaseUseType(newVal) {
      this.currentPage = 1;

      const initList = this.leaseUseTypeList.map((item) => String(item.value));

      this.leaseUseTypeSelectedList = this.screen(
        newVal,
        this.leaseUseTypeSelectedList,
        initList
      );

      this.markerClusterer();
    },

    floorSpace(newVal) {
      this.currentPage = 1;

      this.floorSpaceList = this.screen(newVal, this.floorSpaceList, [
        "1",
        "2",
        "3",
        "4",
        "5",
      ]);

      this.markerClusterer();
    },
  },

  methods: {
    screen(newVal, parmList, initList) {
      let list = Array.isArray(parmList) ? [...parmList] : [];

      if (!newVal || newVal.value === undefined) {
        return list;
      }

      const value = newVal.value;

      if (value === "total") {
        return newVal.checked ? [...initList] : [];
      }

      const isAllSelected =
        initList.length > 0 &&
        list.length === initList.length &&
        initList.every((item) => list.includes(item));

      if (newVal.checked === true) {
        if (isAllSelected) {
          list = [value];
        } else if (!list.includes(value)) {
          list.push(value);
        }
      }

      if (newVal.checked === false) {
        list = list.filter((item) => item !== value);
      }

      return [...new Set(list)];
    },

    markerClusterer() {
      this.loading = true;

      const queryParam = {
        address: this.address,

        includeJinshan: this.districtList.includes("310116"),

        includeOtherRegion: this.districtList.includes("OTHER_REGION"),

        regionCodeList: [...new Set(this.townList)],

        leaseUseType: [...new Set(this.leaseUseTypeSelectedList)],

        floorSpaceList: [...new Set(this.floorSpaceList)],

        page: 1,
        pageSize: 9999,
      };

      console.log("地图找房查询条件：", queryParam);

      listProject(queryParam)
        .then((res) => {
          if (res && res.code === "200") {
            this.asset = res.data || [];
            this.visibleList = this.generateMarker();
            this.currentPage = 1;
          } else {
            this.asset = [];
            this.visibleList = [];
          }
        })
        .catch((err) => {
          console.error("地图找房查询失败", err);
          this.asset = [];
          this.visibleList = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    generateMarker() {
      if (!Array.isArray(this.asset)) {
        return [];
      }

      return this.asset
        .filter((item) => item.longitude && item.latitude)
        .map((item) => {
          return {
            id: item.publishWebId || item.publish_web_id || item.id,

            bizWebId: item.bizWebId,
            bizType: item.bizType,

            housePic:
              Array.isArray(item.housePic) && item.housePic.length > 0
                ? item.housePic[0]
                : item.coverUrl || item.housePic || "",

            lng: Number(item.longitude),
            lat: Number(item.latitude),

            data: {
              address: item.projectName || item.address || "未知地址",

              leaseUseTypeText: this.formatLeaseUseType(item.leaseUseType),

              rentCount: item.rentCount || item.floorSpace || "",

              priceText: this.formatPrice({
                priceType: item.priceType,
                priceMin: item.priceMin,
                priceMax: item.priceMax,
                priceUnit: item.priceUnit,
              }),

              priceType: item.priceType,
              priceMin: item.priceMin,
              priceMax: item.priceMax,
              priceUnit: item.priceUnit,

              traffic: item.publicTransportion || "",
            },

            icon: require("@/assets/locationMap3.png"),
          };
        });
    },

    handleVisibleUpdate(list) {
      this.visibleList = list || [];
      this.currentPage = 1;
    },

    highlight(id) {
      if (this.$refs.mapRef && this.$refs.mapRef.highlightMarker) {
        this.$refs.mapRef.highlightMarker(id);
      }
    },

    unhighlight(id) {
      if (this.$refs.mapRef && this.$refs.mapRef.resetMarkerIcon) {
        this.$refs.mapRef.resetMarkerIcon(id);
      }
    },

    handlePageChange(page) {
      this.currentPage = page;
    },

    onSearch() {
      this.currentPage = 1;
      this.markerClusterer();
    },

    showDetail(item) {
      const bizWebId = item.bizWebId;
      const bizType = item.bizType;

      const url = this.$router.resolve({
        name: "houseDetail",
        query: {
          bizWebId,
          bizType,
        },
      }).href;

      window.open(url, "_blank");
    },

    async loadAreaList(apiFn, errorMsg) {
      if (this.areaList.length > 0) return;
      if (this.areaLoading) return;

      this.areaLoading = true;

      try {
        const res = await apiFn();

        if (res && res.code === "200") {
          this.areaList = res.data || [];
        } else {
          this.areaList = [];
        }
      } catch (e) {
        console.error(errorMsg, e);
        this.areaList = [];
      } finally {
        this.areaLoading = false;
      }
    },

    initAreaVisible() {
      return this.loadAreaList(initAreaListJINSHAN, "行政区划初始化失败");
    },

    async loadLeaseUseTypeList(apiFn, errorMsg) {
      if (this.leaseUseTypeList.length > 0) return;
      if (this.leaseUseTypeLoading) return;

      this.leaseUseTypeLoading = true;

      try {
        const res = await apiFn();

        if (res && res.code === "200") {
          this.leaseUseTypeList = res.data || [];
        } else {
          this.leaseUseTypeList = [];
        }
      } catch (e) {
        console.error(errorMsg, e);
        this.leaseUseTypeList = [];
      } finally {
        this.leaseUseTypeLoading = false;
      }
    },

    initLeaseUseTypeVisible() {
      return this.loadLeaseUseTypeList(
        initLeaseUseType,
        "租赁用途字典初始化失败"
      );
    },

    formatPrice(item) {
      const unitMap = {
        1: "元/月",
        2: "元/年",
        3: "元/㎡/天",
        4: "元/㎡/月",
      };

      const unit = unitMap[Number(item.priceUnit)] || "";

      if (Number(item.priceType) === 2) {
        if (item.priceMin != null && item.priceMax != null) {
          return `${this.formatMoney(item.priceMin)} - ${this.formatMoney(
            item.priceMax
          )}${unit}`;
        }

        if (item.priceMin != null) {
          return `${this.formatMoney(item.priceMin)} 起${unit}`;
        }

        if (item.priceMax != null) {
          return `${this.formatMoney(item.priceMax)} 以内${unit}`;
        }

        return "--";
      }

      if (item.priceMin != null) {
        return `${this.formatMoney(item.priceMin)}${unit}`;
      }

      return "--";
    },

    formatMoney(value) {
      if (value === null || value === undefined || value === "") {
        return "--";
      }

      const num = Number(value);

      if (Number.isNaN(num)) {
        return value;
      }

      return num.toLocaleString("zh-CN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },

    formatLeaseUseType(value) {
      if (!value) {
        return "--";
      }

      const valueArr = String(value).split(",");

      return valueArr
        .map((code) => {
          const dict = this.leaseUseTypeList.find(
            (item) => String(item.value) === String(code)
          );

          return dict ? dict.note : code;
        })
        .join(" / ");
    },
  },
};
</script>

<style lang="less" scoped>
.ant-pro-components-tag-select {
  /deep/ .ant-pro-tag-select .ant-tag {
    margin-right: 24px;
    padding: 0 8px;
    font-size: 14px;
  }
}

.clickable-item {
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 6px;
  padding: 2px 8px;
}

.clickable-item:hover .house-title {
  color: #1677ff;
  text-shadow: 0 0 1px rgba(22, 119, 255, 0.3);
}

.clickable-item:active .house-title {
  color: #0958d9;
}

.house-title {
  color: #333;
  font-weight: bold;
  line-height: 1.4;
  transition: color 0.25s ease, text-shadow 0.25s ease;
}
</style>